// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"349b8895","163":"d332a789","890":"9d099f5d"}[chunkId] + ".chunk.css";
};